





























































import { computed, defineComponent } from '@vue/composition-api'
import useTelemetrySectionUtil from '@/components/RaceVideoPage/RaceVideoDataViewPane/hook/useTelemetrySectionUtil'

/**
 * レース動画再生画面 テレメトリー ブレーキ圧 パーツのコンポーネント
 */
export default defineComponent({
  name: 'TelemetryBrkPressFrParts',
  components: {},
  props: {
    /**
     * バリュー値
     */
    value: {
      type: Number,
      required: true,
      default: 0,
    },
    /**
     * ゲージMAX値
     */
    max: {
      type: Number,
      required: true,
      default: 0,
    },
  },
  setup(props) {
    const { adjustPosition } = useTelemetrySectionUtil()

    // 位置指定を整数化
    adjustPosition('.telemetry-brk-press-fr-parts')

    // ゲージ高さ
    const gaugeSvgHeight = 200

    /**
     * gaugeHeight
     * ゲージの高さを算出
     */
    const gaugeHeight = computed(() => (gaugeSvgHeight * props.value) / props.max)

    /**
     * gaugePositionY
     * ゲージのY位置を算出
     */
    const gaugePositionY = computed(
      () => gaugeSvgHeight - (gaugeSvgHeight * props.value) / props.max,
    )

    return {
      gaugeHeight,
      gaugePositionY,
    }
  },
})
